import { use } from '../../core/use'
import { jsx as f } from '../../jsx-runtime'
import { RouteDepthCtx, useRouter } from '../router'

// Generate a stable key for nested route
function generateOutletKey(match: { route: { path: string }, params: Record<string, string> }, depth: number): string {
    const paramStr = Object.entries(match.params)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([k, v]) => `${k}=${v}`)
        .join('&')
    return `outlet:${depth}:${match.route.path}${paramStr ? '?' + paramStr : ''}`
}

export function Outlet() {
    const routerContext = useRouter()
    const [depthValue] = use(RouteDepthCtx)
    const depth = depthValue ?? 0

    const [matches] = use(() => routerContext.matches)

    if (depth >= matches.length) return null

    const match = matches[depth]
    const Component = match.route.component

    // Guard
    if (match.route.beforeEnter) {
        if (match.route.beforeEnter(match.params) === false) return null
    }

    // Generate key for proper cleanup on nested route changes
    const outletKey = generateOutletKey(match, depth)

    // Render next level with proper key
    return f(RouteDepthCtx.Provider, {
        value: depth + 1,
        key: outletKey,
        children: f(Component, { params: match.params })
    })
}
